import { ResolveFn } from '@angular/router';
import { CasiStoryType } from '../models/models.lib';
import { inject } from '@angular/core';
import { UserStoryTypesService } from '../tracker/user-story-types.service';

export const casiStoryTypesResolver: ResolveFn<CasiStoryType> = (route, state) => {
  return inject(UserStoryTypesService).get();
};
